module.exports = __webpack_public_path__ + "img/vip_free_ends_today.8608c3f8.png";